<template>
  <div class="register-container">
    <div class="register-card">
      <div class="register-header">
        <h2 class="register-title">商铺注册</h2>
        <p class="register-subtitle">请填写以下信息完成注册</p>
      </div>

      <el-form ref="registerForm" :model="registerInfo" label-width="0" class="register-form">
        <!-- 地区选择 -->
        <el-form-item>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-select v-model="registerInfo.selectProv" @change="getProv" placeholder="请选择省" class="custom-select" style="width:100%">
                <el-option v-for="(item, index) in registerInfo.provs" :key="index" :label="item.areaName"
                  :value="item.areaCode">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select v-model="registerInfo.selectCity" @change="getCity" placeholder="请选择城市" class="custom-select" style="width:100%">
                <el-option v-for="(item, index) in registerInfo.citys" :key="index" :label="item.areaName"
                  :value="item.areaCode">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select v-model="registerInfo.selectArea" @change="getArea" placeholder="请选择区县" class="custom-select" style="width:100%">
                <el-option v-for="(item, index) in registerInfo.areas" :key="index" :label="item.areaName"
                  :value="item.areaCode">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>

        <!-- 商铺名称 -->
        <el-form-item>
          <el-input v-model="registerInfo.shopName" placeholder="请输入商铺名称" class="custom-input">
          </el-input>
        </el-form-item>

        <!-- 商铺类型 -->
        <el-form-item>
          <el-select v-model="registerInfo.shopType" placeholder="请选择商铺类型" style="width:100%" class="custom-select">
            <el-option v-for="(item, index) in registerInfo.shopTypes" :key="index" :label="item.typeName"
              :value="item.shopTypeId">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 手机号 -->
        <el-form-item>
          <el-input v-model="registerInfo.tel" placeholder="请输入手机号" maxlength="20" class="custom-input">
          </el-input>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item>
          <el-input v-model="registerInfo.passwd" placeholder="请输入密码" type="password" maxlength="20" show-password
            class="custom-input">
          </el-input>
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item >
          <div class="code-container">
            <el-input v-model="registerInfo.messageCode" placeholder="请输入短信验证码" maxlength="6" class="code-input">
            </el-input>
            <el-button :disabled="registerInfo.buttonInfo !== '验证码'" @click="sendTelMessageCode" class="code-button">
              {{ registerInfo.buttonInfo }}
            </el-button>
          </div>
        </el-form-item>

        <!-- 注册按钮 -->
        <el-form-item>
          <el-button type="primary" @click="doRegister" class="register-button">
            注册
          </el-button>
        </el-form-item>

        <!-- 登录链接 -->
        <div class="login-link">
          <span>已有账号？</span>
          <el-link type="primary" @click="handleLogin">立即登录</el-link>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getAreaList, getShopTypes, registerStore, sendSms } from '@/api/frame/register/registerApi'

export default {
  name: 'ShopRegister',
  data() {
    return {
      registerInfo: {
        shopName: '',
        tel: '',
        passwd: '',
        logo: '',
        areas: [],
        provs: [],
        citys: [],
        selectProv: '',
        selectCity: '',
        selectArea: '',
        areaAddress: '',
        areaCode: '',
        shopType: '',
        shopTypes: [],
        messageCode: '',
        buttonInfo: '验证码'
      }
    }
  },
  created() {
    this.initArea('101', '0')
    this.listShopTypes()
  },
  methods: {
    initArea(areaLevel, parentAreaCode) {
      getAreaList({ areaLevel, parentAreaCode }).then(res => {
        const areas = res.data
        if (areaLevel === '101') {
          this.registerInfo.provs = areas
        } else if (areaLevel === '202') {
          this.registerInfo.citys = areas
        } else {
          this.registerInfo.areas = areas
        }
      }).catch(() => {
        this.$message.error('查询地区失败')
      })
    },
    getProv(prov) {
      this.initArea('202', prov)
    },
    getCity(city) {
      this.initArea('303', city)
    },
    getArea(area) {
      this.registerInfo.areaAddress = ''
      this.registerInfo.areaCode = area

      if (!this.registerInfo.provs) return

      const prov = this.registerInfo.provs.find(p => p.areaCode === this.registerInfo.selectProv)
      if (prov) this.registerInfo.areaAddress = prov.areaName

      const city = this.registerInfo.citys.find(c => c.areaCode === this.registerInfo.selectCity)
      if (city) this.registerInfo.areaAddress += city.areaName

      const areaObj = this.registerInfo.areas.find(a => a.areaCode === this.registerInfo.selectArea)
      if (areaObj) this.registerInfo.areaAddress += areaObj.areaName
    },
    listShopTypes() {
      getShopTypes({ page: 1, row: 100 }).then(res => {
        this.registerInfo.shopTypes = res.data
      })
    },
    validate() {
      if (!this.registerInfo.shopName) {
        this.$message.error('商铺名不能为空')
        return false
      }
      if (!this.registerInfo.passwd) {
        this.$message.error('密码不能为空')
        return false
      }
      if (!this.registerInfo.tel) {
        this.$message.error('手机号不能为空')
        return false
      }
      if (!this.registerInfo.messageCode) {
        this.$message.error('验证码不能为空')
        return false
      }
      if (!this.registerInfo.areaCode) {
        this.$message.error('地区不能为空')
        return false
      }
      return true
    },
    doRegister() {
      if (!this.validate()) return

      const params = {
        shopName: this.registerInfo.shopName,
        link: this.registerInfo.tel,
        password: this.registerInfo.passwd,
        areaAddress: this.registerInfo.areaAddress,
        areaCode: this.registerInfo.areaCode,
        shopType: this.registerInfo.shopType,
        msgCode: this.registerInfo.messageCode,
      }

      registerStore(params).then(res => {
        if (res.code === 0) {
          this.$router.push('/')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    sendTelMessageCode() {
      if (!this.registerInfo.tel) {
        this.$message.error('手机号码为空或不正确，不能发送验证码')
        return
      }
      if (this.registerInfo.buttonInfo !== '验证码') return

      this.messageCodeTimer()

      sendSms({ tel: this.registerInfo.tel }).then(res => {
        if (res.code === 0) {
          this.$message.success(res.data)
        }
      })
    },
    messageCodeTimer() {
      let num = 60
      const timer = setInterval(() => {
        num--
        this.registerInfo.buttonInfo = `${num}秒后重试`
        if (num === 1) {
          clearInterval(timer)
          this.registerInfo.buttonInfo = '验证码'
        }
      }, 1000)
    },
    handleLogin() {
      this.$router.push('/views/frame/login')
    }
  }
}
</script>

<style scoped>
.register-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(45deg, #FE7910, #ff9f55);
  padding: 20px;
}

.register-card {
  width: 100%;
  max-width: 600px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  padding: 40px;
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.register-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 10px;
}

.register-subtitle {
  font-size: 14px;
  color: #6b7280;
}

.register-form {
  margin-bottom: 20px;
}

.custom-input>>>.el-input__inner {
  height: 50px;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  background: rgba(239, 50, 28, 0.08);
  font-size: 14px;
  transition: all 0.3s ease;
}

.custom-input>>>.el-input__inner:focus {
  border-color: #FE7910;
  /*background: white;*/
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-select>>>.el-input__inner {
  height: 50px;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
    background: rgba(239, 50, 28, 0.08);
  font-size: 14px;
  transition: all 0.3s ease;
}

.custom-select>>>.el-input__inner:focus {
  border-color: #FE7910;
  /*background: white;*/
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-code {
  display: flex;
  align-items: center;
}

.code-container {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
}

.code-input {
  width: 80%;
  flex: 1;
}

.code-input>>>.el-input__inner {
  height: 50px;

  border-radius: 12px;
  border: 2px solid #e5e7eb;
  background: rgba(239, 50, 28, 0.08);
  font-size: 14px;
  transition: all 0.3s ease;
}

.code-input>>>.el-input__inner:focus {
  border-color: #FE7910;
  /*background: white;*/
  box-shadow: 0 0 0 3px rgba(255, 98, 71, 0.1);
}

.code-button {
  width: 120px;
  height: 50px;
  border-radius: 12px;
  font-size: 14px;
  flex-shrink: 0;
}
.code-button:hover{
    background: none;
}

.register-button {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(90deg, #ff6247, #ee3111);
  border: none;
  transition: all 0.3s ease;
}

.register-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(255, 98, 71, 0.3);
}

.register-button:active {
  transform: translateY(0);
}

.login-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: black;
}

.login-link .el-link,.login-link .el-link:hover {
  margin-left: 5px;
  color: #ee3111;
}

.el-link.el-link--default:after, .el-link.el-link--primary.is-underline:hover:after, .el-link.el-link--primary:after{
    border-color: #ee3111;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .register-container {
    padding: 10px;
  }

  .register-card {
    padding: 30px 20px;
  }

  .register-title {
    font-size: 24px;
  }
}
</style>